// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgageRequestSimpleNoteRequestWizard } = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestWizard/mortgageRequestSimpleNoteRequestWizard');

class MortgageRequestSimpleNoteRequestView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    handleCancel() {
        this.props.history.push('/myprofile/mortgage/panel');
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestSimpleNote-title'),
                url: '/'
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        return (
            <div className="mortgage-request-simple-note-request-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestSimpleNote-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-offset-2 col-xs-8">
                                <MortgageRequestSimpleNoteRequestWizard
                                    onCancel={this.handleCancel} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestSimpleNoteRequestView.propTypes = {
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
}

module.exports = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(withRouter(MortgageRequestSimpleNoteRequestView));
